import type { OverdueSummaryData } from '@ctct/application-layer';
import { OrderSummary } from '@ctct/presentation-layer';

interface Props {
  data: OverdueSummaryData;
}

export const OverdueSummaryWidgetContent = ({ data }: Props) => {
  const copies = data.getCopies();
  const orderRows = data.getOrderRows();
  const footerRows = data.getFooterRows();

  return <OrderSummary copies={copies} orderItems={orderRows} footerItems={footerRows} />;
};
